import type { ReactNode } from "react";
import { AlertOctagon, AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { cx } from "../cx.js";
import styles from "./Banner.module.css";

export type BannerTone = "info" | "warning" | "danger" | "success";

const ICONS = { info: Info, warning: AlertTriangle, danger: AlertOctagon, success: CheckCircle2 } as const;

export interface BannerProps {
  tone?: BannerTone;
  title?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  /** Gefahr-Hinweise werden sofort vorgelesen (role=alert), sonst höflich (role=status) */
  live?: boolean;
  className?: string;
}

export function Banner({ tone = "info", title, children, actions, live = true, className }: BannerProps) {
  const Icon = ICONS[tone];
  const role = live ? (tone === "danger" ? "alert" : "status") : undefined;
  return (
    <div role={role} className={cx(styles.banner, styles[tone], className)}>
      <Icon className={styles.icon} aria-hidden="true" />
      <div className={styles.body}>
        {title ? <p className={styles.title}>{title}</p> : null}
        {children ? <div className={styles.text}>{children}</div> : null}
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </div>
  );
}
